module.exports = __webpack_public_path__ + "static/mouse-movement-554366caf5328d67a239359f1f0d3a5f.png";